import produce from 'immer';

import Types from './types';

const INITIAL_STATE = {
  user: null,
  authenticated: false,
  loading: false,
};

export default function auth(state = INITIAL_STATE, { type, payload }) {
  return produce(state, draft => {
    switch (type) {
      case Types.SIGN_IN:
        draft.loading = true;
        break;
      case Types.SIGN_OUT:
        draft.loading = false;
        draft.user = null;
        draft.authenticated = false;
        break;
      case Types.SIGN_IN_FAILURE:
        draft.loading = false;
        break;
      case Types.SIGN_IN_SUCCESS:
        draft.loading = false;
        draft.authenticated = true;
        draft.user = payload.user;
        break;
      default:
        break;
    }
  });
}
